module.exports = __webpack_public_path__ + "static/photo-vimal-dd1cc7becb9ea70a671d9f508b06910f.jpg";